export const RECIPE_VIDEO = {
    videoFrame: "px-10 lg:px-0 md:w-[615px] md:h-[346px] h-[222px] mx-auto w-full absolute top-0",
    videoFrameHide: "lg:px-0 md:w-[615px] md:h-[346px] h-[222px] w-full mx-auto px-10 absolute top-0",
    showImg:"md:w-[615px] md:h-[346px] h-[222px] rounded-20 absolute z-[1] px-10 md:px-0",
    hideImg: "hidden px-10",
    playBtnImg:"w-full h-full rounded-20",
    videoItem: "w-full h-full min-h-full rounded-20",
    videoCntr: "md:w-[615px] md:h-[346px] h-[222px] w-full md:mx-auto  mb-[72px] relative",
    playButton: "absolute  top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] rounded-full lg::mt-[15%] lg:mt-auto bg-arrowBg "
  }